const en = {
  login: 'Login',
  account: 'Account',
  connect: 'Connect Wallet',
  mint: 'Inscribe',
  repeatTime: 'Repeat Times',
  hexString: 'Hex String',
  textString: 'Text String',
  inscribeContent: 'Inscribe Content',
  network: 'Network',
  easyInsc: 'Easy Inscription',
  switchNetwork: 'Switch Network',
  minting: 'Inscribing',
  currentAddress: 'Current address',
  currentChain: 'Current Network',
  repeatTips: 'You need to sign for each inscribe',
  downloadTP: 'Please download TokenPocket to use: <a href="https://tokenpocket.pro/?from=insc" target="_blank"> TokenPocket Wallet</a>'
};

export default en;